import PropTypes from 'prop-types';
import React from 'react';
import Link from 'react-router/lib/Link';

import SimpleHeader from '../../../main/headers/simpleHeader';

const ShopLayout = ({ title, shopId, barberId, routeName, children }) => (
  <div>
    <SimpleHeader heading={title} />
    <div className="u-max-width-710 u-margin-auto u-ph- large-and-up-ph0">
      <ul className="c-nav-tabs list-bare u-mt- medium-and-up-mt" display-if={!barberId}>
        <li>
          <Link to={`/admin/shops/${shopId}`} activeClassName="is-active" className="c-nav-tab">
            Main <br /> Settings
          </Link>
        </li>
        <li>
          <Link to={`/admin/shops/${shopId}/payment`} activeClassName="is-active" className="c-nav-tab">
            Payment <br /> Settings
          </Link>
        </li>
        <li>
          <Link to={`/admin/shops/${shopId}/import`} activeClassName="is-active" className="c-nav-tab">
            Import
          </Link>
        </li>
        <li>
          <Link to={`/admin/shops/${shopId}/subscription`} activeClassName="is-active" className="c-nav-tab">
            Subscription
          </Link>
        </li>
        <li>
          <Link to={`/admin/shops/${shopId}/loan`} activeClassName="is-active" className="c-nav-tab">
            Loan
          </Link>
        </li>
        <li>
          <Link to={`/admin/shops/${shopId}/hourly-wage-rules`} activeClassName="is-active" className="c-nav-tab">
            Hourly Wage Rules
          </Link>
        </li>
      </ul>
      <Link
        display-if={routeName === 'payment' && barberId}
        to={`/admin/shops/${shopId}/payment`}
        className="c-btn c-btn--outline c-btn--outline-grey c-btn--small u-mv"
      >
        Back to shop
      </Link>
      <Link
        display-if={routeName === 'subscription' && barberId}
        to={`/admin/shops/${shopId}/subscription`}
        className="c-btn c-btn--outline c-btn--outline-grey c-btn--small u-mv"
      >
        Back to shop
      </Link>
    </div>
    <div className="u--mt-- large-and-up--mt">{children}</div>
  </div>
);
ShopLayout.propTypes = {
  children: PropTypes.node.isRequired,
  shopId: PropTypes.string.isRequired,
  barberId: PropTypes.string,
  title: PropTypes.string.isRequired,
  routeName: PropTypes.string,
};
ShopLayout.defaultProps = {
  barberId: '',
  routeName: '',
};

export default ShopLayout;
